var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngadget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-1 8 20 20",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24.1C0 25.7 1.3 27 3 27h12v-3H3v-3h11.8c1.6 0 3.2-1.3 3.2-2.9v.1-5.9c0-1.6-1.5-3.2-3.2-3.2H3c-1.6 0-3 1.6-3 3.2v11.8zM15 18H3v-6h12v6zm40.1-9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngadget);
export default __webpack_public_path__ + "static/media/engadget.28c4b8491b7b1abaf4e7705886c1fa2d.svg";
export { ForwardRef as ReactComponent };